import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { GlobalStyle } from "./GlobalStyle"
import App from "./App"

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
    <GlobalStyle />
      <App />
    </BrowserRouter>
  </React.StrictMode>
)